import fs from 'fs';
import _ from 'lodash';
import path from 'path';

export default function vaultSetup(): object {
  // eslint-disable-next-line functional/no-try-statement
  try {
    const contents = fs.readFileSync(path.resolve('/vault/secrets/', 'secrets.txt'), 'utf8');
    const settings = contents.split('\n').filter((c) => _.trim(c) !== '')
      .reduce((prev: object, cur: string): object => {
        const key = cur.split(/: /, 1)[0];
        const value = cur.replace(`${key}: `, '').trim();
        const res: { readonly [key: string]: any } = prev;
        return _.set(res, key, value);
      }, {});
    return settings;
  } catch (ex) {
    return {};
  }
}
